import {
  GearSixIcon,
  QuestionIcon,
  SignOutIcon,
  ArrowSquareOutIcon
} from '@phosphor-icons/react';

import router from 'next/router';
import { useTeamsData } from '@lib/hooks/useTeamsData';
import Avatar from '@atoms/Avatar';
import Button from '@atoms/Button.new';

import {
  Dropdown,
  DropdownMenu,
  DropdownTrigger,
  DropdownItem,
  DropdownSection
} from '@atoms/new/dropdown';

import { useZoomData } from '@lib/hooks/useZoomData';
import ExternalLink from '@zoom-app/atoms/ExternalLink';

const DropdownDestination = (props) => {
  const { currentTeam, user } = useTeamsData((s) => ({ currentTeam: s.currentTeam, user: s.user }));

  const isLoggedIn = useZoomData((s) => s.isLoggedIn);

  if (!currentTeam) {
    return <></>;
  }

  return (
    <div id="DropdownDestination" className="">
      <div className='flex'>
        {isLoggedIn() ? (
          <Dropdown
            placement="top-end"
            triggerScaleOnOpen={false}
            disableAnimation
          >
            <DropdownTrigger>
              <div>
                <Avatar
                  w='8'
                  h='8'
                  name={user?.email || 'Guest'}
                  isProfile={true}
                />
              </div>
            </DropdownTrigger>
            <DropdownMenu
              itemClasses={{
                base: 'hover:bg-red-500',
              }}
              onAction={(id) => {
                // console.log('Hello world');
              }}
              aria-label="Dropdown menu for list of presentations"
              selectionMode="none"
              topContent={
                <div className='text-sm font-normal text-default-500 py-[6px] px-4'>
                  {user.user_role === 'guest' ? 'Guest Mode' : user.email}
                </div>
              }
            >
              <DropdownSection
                showDivider
                className="m-0!"
                classNames={{
                  divider: 'mt-0 mb-0',
                }}
              />
              <DropdownSection
                showDivider
                className="m-0!"
                classNames={{
                  divider: 'mt-0 mb-0',
                }}
              >
                <DropdownItem
                  key="Settings"
                  textValue="Settings"
                  onAction={() => router.push('/zoom-app/settings')}
                  startContent={<GearSixIcon size={20} />}
                >
                  Settings
                </DropdownItem>

                <DropdownItem
                  key="HelpCenter"
                  textValue="Help center"
                  startContent={<QuestionIcon size={20} />}
                >
                  <ExternalLink href="https://help.streamalive.com/collections/6758003-zoom-application">Help center <span className="inline-block"><ArrowSquareOutIcon /></span></ExternalLink>
                </DropdownItem>

              </DropdownSection>

              <DropdownItem
                key="Logout"
                textValue="Logout"
                onAction={() => props.logout()}
                startContent={<SignOutIcon size={20} />}
                classNames={{
                  base: 'text-danger hover:text-danger',
                }}
              >
                Logout
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        ) : (
          <div className="flex">
            <div
              className="ml-2 w-[154px] md:w-fit"
              onClick={() => { router.push('/zoom-app'); }}
            >
              <Button
                variant="tertiary"
                fullWidth
              >
                Login
              </Button>
            </div>
          </div>
        )}
      </div >
    </div >
  );
};

export default DropdownDestination;
